const socialLink={
    fb:'https://www.facebook.com/apurvasoftwaresolns',
    instagram:'https://www.instagram.com/apurvasoftwaresolutions/',
    linkedIn:'https://www.linkedin.com/company/105148128/admin/dashboard/',
    twitter:'https://x.com/ApurvaSoftware',
    pinterest:'https://in.pinterest.com/apurvasoftwaresolutions/'
  }

  export default  socialLink;